
import React, { useState } from "react";
import { Investor } from "@/types/investor";
import InvestorCardItem from "./InvestorCardItem";
import InvestorDetailsDialog from "./InvestorDetailsDialog";

interface InvestorsCardViewProps {
  investors: Investor[];
  selectedInvestor: Investor | null;
  onSelectInvestor: (investor: Investor) => void;
  isEnriching: boolean;
  onEnrichInvestor?: (investor: Investor) => Promise<Investor>;
  isInvestorEnriching?: (id: string) => boolean;
  isInvestorProcessed?: (investor: Investor) => boolean;
}

const InvestorsCardView = ({ 
  investors, 
  selectedInvestor, 
  onSelectInvestor,
  isEnriching,
  onEnrichInvestor,
  isInvestorEnriching,
  isInvestorProcessed = () => false
}: InvestorsCardViewProps) => {
  const [viewDialogInvestor, setViewDialogInvestor] = useState<Investor | null>(null);
  
  return (
    <>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {investors.length > 0 ? (
          investors.map((investor) => (
            <InvestorCardItem
              key={investor.id}
              investor={investor}
              isSelected={selectedInvestor?.id === investor.id}
              onSelectInvestor={onSelectInvestor}
              onEnrichInvestor={onEnrichInvestor}
              isInvestorEnriching={isInvestorEnriching}
              isInvestorProcessed={isInvestorProcessed}
              onViewInvestor={(inv) => setViewDialogInvestor(inv)}
            />
          ))
        ) : (
          <div className="col-span-full text-center py-8 text-gray-500">
            No investors found.
          </div>
        )}
      </div>

      {/* Dialog to show detailed investor information */}
      <InvestorDetailsDialog
        investor={viewDialogInvestor}
        onClose={() => setViewDialogInvestor(null)}
      />
    </>
  );
};

export default InvestorsCardView;
